/* Publish by EComposer at 2025-08-06 02:43:09*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vd8cguclvf9"]=  window.__ectimmers["ecom-vd8cguclvf9"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-vd8cguclvf9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vd8cguclvf9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ydjtdnjqeno').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ydjtdnjqeno', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-snozh0c1yt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-snozh0c1yt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-32wafgi0sbe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-32wafgi0sbe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ssrap02w8y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ssrap02w8y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qiymm203y1o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qiymm203y1o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o19et4zzhwp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o19et4zzhwp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2akb3uq95m7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2akb3uq95m7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4fbon9crm2w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4fbon9crm2w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5zywmzmdadm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5zywmzmdadm', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-w7d0bu8pduc"]=  window.__ectimmers["ecom-w7d0bu8pduc"] || {};
const e=this.$el;if(!e||!this.isLive)return;const i=e.querySelector(".element__featured--wrapper-list");if(i){let t={top:0,left:0,x:0,y:0};const n=function(a){const r=a.clientX-t.x;i.scrollLeft=t.left-r},s=function(){i.removeEventListener("mousemove",n),i.removeEventListener("mouseup",s),i.style.cursor="default",i.style.removeProperty("user-select")},o=function(a){i.style.cursor="grabbing",i.style.userSelect="none",t={left:i.scrollLeft,top:i.scrollTop,x:a.clientX,y:a.clientY},i.addEventListener("mousemove",n),i.addEventListener("mouseup",s)};i.addEventListener("mousedown",o),i.addEventListener("mouseleave",s)}

                    });
                    
                        document.querySelectorAll('.ecom-w7d0bu8pduc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w7d0bu8pduc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9kaos2pum0j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9kaos2pum0j', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9qybsxddosf"]=  window.__ectimmers["ecom-9qybsxddosf"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-9qybsxddosf"]["xy0hf0p81"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},s);Shopify.analytics.publish("ec_custom_events",o),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-9qybsxddosf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9qybsxddosf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4w2615pirs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4w2615pirs', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-m14ed0upigs"]=  window.__ectimmers["ecom-m14ed0upigs"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-m14ed0upigs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m14ed0upigs', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iv5m6adnl3l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iv5m6adnl3l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pazpaqyfztn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pazpaqyfztn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rq1acgtshg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rq1acgtshg', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-slrtkcfman9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-slrtkcfman9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rcfcyom9wk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rcfcyom9wk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j9tnj2172nj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j9tnj2172nj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-70l9mtua099').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-70l9mtua099', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4dwx84u85ra').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4dwx84u85ra', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}